<template>
    <div v-if="setup_data != null">

        <p class="mt-2">
            Please select the integrations you plan to use below, <b><u>read and follow the associated directions to get
                    started</u></b>.
        </p>

        <v-checkbox
            label="Bottle360"
            :value="isIntegrationOn('bottle360')"
            v-on:change="setIntegration($event, 'bottle360')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('bottle360')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p>
                Bottle360 will help you set up your integration with RedChirp. To get started, reach out to
                <a href="mailto:support@bottlethreesixty.com">support@bottlethreesixty.com</a>.
            </p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('bottle360')"
                @change="setIntegrationCompleted($event, 'bottle360')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>

        <v-checkbox
            label="Commerce7"
            :value="isIntegrationOn('commerce7')"
            v-on:change="setIntegration($event, 'commerce7')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('commerce7')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p>To connect Commerce7 and RedChirp, install the RedChirp Commerce7 app. Click <a
                    href="https://redchirp.com/how-to-connect-redchirp-and-commerce7/"
                    target="_blank"
                >here</a> for instructions.</p>
            <p>
                Our team will be notified when your part is done. We will enter your tenant and finish the integration
                setup for you.
            </p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('commerce7')"
                @change="setIntegrationCompleted($event, 'commerce7')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>

        <v-checkbox
            label="Copper Peak Logistics"
            :value="isIntegrationOn('copper-peak')"
            v-on:change="setIntegration($event, 'copper-peak')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('copper-peak')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p>To activate your RedChirp integration, simply email <a
                    href="mailto:manderson@copperpeaklogistics.com">manderson@copperpeaklogistics.com</a> and copy <a
                    href="mailto:help@redchirp.com"
                >help@redchirp.com</a> to let Copper Peak Logistics know you'd like it turned on—they'll handle the
                rest.
            </p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('copper-peak')"
                @change="setIntegrationCompleted($event, 'copper-peak')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>

        <v-checkbox
            label="Corksy"
            :value="isIntegrationOn('corksy')"
            v-on:change="setIntegration($event, 'corksy')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('corksy')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p>
                Corksy will help you set up your integration with RedChirp. To get started, reach out to
                <a href="mailto:support@corksy.io">support@corksy.io</a>.
            </p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('corksy')"
                @change="setIntegrationCompleted($event, 'corksy')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>

        <v-checkbox
            label="eCELLAR"
            :value="isIntegrationOn('ecellar')"
            v-on:change="setIntegration($event, 'ecellar')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('ecellar')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p>
                eCELLAR charges a one-time fee to complete this integration, and a monthly fee while it's in use. Please
                contact eCELLAR for exact fee details if you're interested in this integration.
            </p>

            <p>If you would like to proceed, check the box below and we'll request the integration from eCELLAR.</p>

            <v-checkbox
                label="I understand eCELLAR's fees and would like to proceed with this integration."
                v-model="setup_data.accept_ecellar_fee"
                v-on:change="doUpdate"
                hide-details
            />

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('ecellar')"
                @change="setIntegrationCompleted($event, 'ecellar')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>

        <v-checkbox
            label="Klaviyo"
            :value="isIntegrationOn('klaviyo')"
            v-on:change="setIntegration($event, 'klaviyo')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('klaviyo')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p>Thanks for letting us know! Our team will help you with this integration after your launch. </p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('klaviyo')"
                @change="setIntegrationCompleted($event, 'klaviyo')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>

        <v-checkbox
            label="Mailchimp"
            :value="isIntegrationOn('mailchimp')"
            v-on:change="setIntegration($event, 'mailchimp')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('mailchimp')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p>Thanks for letting us know! Our team will help you with this integration after your launch. </p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('mailchimp')"
                @change="setIntegrationCompleted($event, 'mailchimp')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>


        <v-checkbox
            label="Offset"
            :value="isIntegrationOn('offset')"
            v-on:change="setIntegration($event, 'offset')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('offset')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p>To connect Offset and RedChirp, email <a
                    href="mailto:support@offsetpartners.com">support@offsetpartners.com</a> to request your RedChirp
                integration turned on.</p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('offset')"
                @change="setIntegrationCompleted($event, 'offset')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>


        <v-checkbox
            label="OrderPort"
            :value="isIntegrationOn('order-port')"
            v-on:change="setIntegration($event, 'order-port')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('order-port')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p>
                To activate your RedChirp integration, email <a
                    href="mailto:traci@orderport.net">Traci@orderport.net</a>
                and copy <a href="mailto:help@redchirp.com">help@redchirp.com</a>, letting OrderPort know you'd like it
                turned on. They'll take care of the rest.
            </p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('order-port')"
                @change="setIntegrationCompleted($event, 'order-port')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>

        <v-checkbox
            label="Outshinery"
            :value="isIntegrationOn('outshinery')"
            v-on:change="setIntegration($event, 'outshinery')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('outshinery')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p>Thanks for letting us know! We'll work with Outshinery to get this set up for you.</p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('outshinery')"
                @change="setIntegrationCompleted($event, 'outshinery')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>

        <v-checkbox
            label="ShipCompliant"
            :value="isIntegrationOn('ship-compliant')"
            v-on:change="setIntegration($event, 'ship-compliant')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('ship-compliant')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p class="mt-3">Turn on the RedChirp &lt;&gt; Savos ShipCompliant integration in 3 easy steps:
            </p>
            <ul>
                <li>Create a web service account in Sovos ShipCompliant</li>
                <li>Turn on the ShipCompliant integration in RedChirp</li>
                <li>Let us know so we can confirm everything for you.</li>
            </ul>
            <p class="mt-3">You can find thorough instructions <a
                    target="_blank"
                    href="https://redchirp.com/redchirp-integration-shipcompliant/"
                >
                    here
                </a>.
            </p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('ship-compliant')"
                @change="setIntegrationCompleted($event, 'ship-compliant')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>

        <v-checkbox
            label="ShipEngine"
            :value="isIntegrationOn('ship-engine')"
            v-on:change="setIntegration($event, 'ship-engine')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('ship-engine')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p class="mt-3">
                Thanks for letting us know! Our team will help you with this integration after
                your launch.
            </p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('ship-engine')"
                @change="setIntegrationCompleted($event, 'ship-engine')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>

        <v-checkbox
            label="Shopify"
            :value="isIntegrationOn('shopify')"
            v-on:change="setIntegration($event, 'shopify')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('shopify')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p class="mt-3">
                To connect to Shopify, follow <a @click="$refs['shopify-install-instructions'].showDialog()">these
                    instructions</a> to install the RedChirp app in the Shopify App Store.
            </p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('shopify')"
                @change="setIntegrationCompleted($event, 'shopify')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>

        <v-checkbox
            label="tock"
            :value="isIntegrationOn('tock')"
            v-on:change="setIntegration($event, 'tock')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('tock')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p class="mt-3">To connect to Tock, have your Tock Account Owner send an email to <a
                    href="mailto:integrate@tockhq.com"
                >integrate@tockhq.com</a> requesting that RedChirp be granted API access to your Tock account(s).
            </p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('tock')"
                @change="setIntegrationCompleted($event, 'tock')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>

        <v-checkbox
            label="VinesOS"
            :value="isIntegrationOn('vines-os')"
            v-on:change="setIntegration($event, 'vines-os')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('vines-os')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p>Email <a href="mailto:support@VinesOS.com">support@VinesOS.com</a>, and copy <a
                    href="mailto:help@RedChirp.com"
                >help@RedChirp.com</a>, to let VinesOS know that you would like your RedChirp integration turned on.
                VinesOS will handle the rest.</p>
            <p>
                Please note: VinesOS charges a one-time $100 fee to set up the RedChirp integration for those on their
                Starter plan; they do not charge any fees to set up the RedChirp integration for those on their Standard
                or higher plans.
            </p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('vines-os')"
                @change="setIntegrationCompleted($event, 'vines-os')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>

        <v-checkbox
            label="Vinoshipper"
            :value="isIntegrationOn('vinoshipper')"
            v-on:change="setIntegration($event, 'vinoshipper')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('vinoshipper')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p>Thanks for letting us know! Our team will help you with this integration after your launch.</p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('vinoshipper')"
                @change="setIntegrationCompleted($event, 'vinoshipper')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>

        <v-checkbox
            label="VinSuite"
            :value="isIntegrationOn('vinsuite')"
            v-on:change="setIntegration($event, 'vinsuite')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('vinsuite')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p>Thanks for letting us know! We'll work with VinSuite to get this set up for you.</p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('vinsuite')"
                @change="setIntegrationCompleted($event, 'vinsuite')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>

        <v-checkbox
            label="WineDirect (Classic)"
            :value="isIntegrationOn('winedirect')"
            v-on:change="setIntegration($event, 'winedirect')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('winedirect')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p>To connect WineDirect and RedChirp, follow these <a
                    href="https://redchirp.com/how-to-connect-redchirp-and-winedirect/"
                    target="_blank"
                >quick 2-step instructions
                </a>.
            </p>
            <p>
                Our team will be notified when your part is done and will be happy to complete your integration for you.
            </p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('winedirect')"
                @change="setIntegrationCompleted($event, 'winedirect')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>

        <v-checkbox
            label="WineDirect (All New / BigCommerce)"
            :value="isIntegrationOn('winedirect-big-commerce')"
            v-on:change="setIntegration($event, 'winedirect-big-commerce')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('winedirect-big-commerce')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p>Thanks for letting us know! Our team will help you with this integration after your launch.</p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('winedirect-big-commerce')"
                @change="setIntegrationCompleted($event, 'winedirect-big-commerce')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>

        <v-checkbox
            label="WineDirect Fulfillment"
            :value="isIntegrationOn('wine-direct-fulfillment')"
            v-on:change="setIntegration($event, 'wine-direct-fulfillment')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('wine-direct-fulfillment')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p>
                Tell your customer service contact at WineDirect Fulfillment that you would like your RedChirp
                integration turned on.
            </p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('wine-direct-fulfillment')"
                @change="setIntegrationCompleted($event, 'wine-direct-fulfillment')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>

        <v-checkbox
            label="Wineshipping"
            :value="isIntegrationOn('wine-shipping')"
            v-on:change="setIntegration($event, 'wine-shipping')"
            hide-details
        />

        <div
            class="instructions"
            v-if="isIntegrationOn('wine-shipping')"
        >
            <div class="next-steps-header">Next Steps</div>
            <p>
                To connect Wineshipping and RedChirp, tell your customer service contact at Wineshipping that you would
                like your RedChirp integration turned on.
            </p>

            <v-switch
                label="I have finished this"
                :value="isIntegrationCompleted('wine-shipping')"
                @change="setIntegrationCompleted($event, 'wine-shipping')"
                class="completion-switch"
                v-if="!was_already_complete"
            />
        </div>

        <div
            class="section-completion"
            v-if="hasSelectedIntegrations"
        >
            <v-alert
                v-if="!provision && !allSelectedIntegrationsCompleted && !was_already_complete"
                type="error"
                dense
                class="mb-2"
            >
                You must complete all selected integrations above before marking this section as complete.
            </v-alert>

            <v-switch
                label="This section is complete"
                :value="(setup_data.complete && allSelectedIntegrationsCompleted) || was_already_complete"
                :disabled="!allSelectedIntegrationsCompleted && !was_already_complete"
                @change="setSectionComplete($event)"
                v-if="!provision"
            />

            <v-switch
                label="This section is complete (does not affect the welcome screen)"
                v-model="profile.provision_info.complete_integrations"
                @change="doUpdate"
                v-if="provision"
            />
        </div>

        <div v-else>
            <v-switch
                label="This section is complete"
                v-model="setup_data.complete"
                v-on:change="doUpdate"
                v-if="!provision"
            />

            <v-switch
                label="This section is complete (does not affect the welcome screen)"
                v-model="profile.provision_info.complete_integrations"
                v-on:change="doUpdate"
                v-if="provision"
            />
        </div>

        <m-shopify-install-instructions ref="shopify-install-instructions" />
    </div>
</template>

<script>
import _ from 'lodash';
import MShopifyInstallInstructions from '@/views/integrations/shopify/shopify-install-instructions.vue';

export default
    {
        name: 'WelcomeIntegrations',

        components: {
            MShopifyInstallInstructions
        },

        props: {
            profile: {
                type: Object,
                default: function () { return {}; },
            },

            provision: {
                type: Boolean,
                default: function () { return false; },
            },
        },

        data() {
            return {
                setup_data: {},
                integration_completions: {},
                was_already_complete: false, // backwards compatibility for existing profiles
            }
        },

        mounted() {
            this.setup_data = _.cloneDeep(this.profile.integration_settings);
            this.integration_completions = _.cloneDeep(this.profile.integration_settings.integration_completions || {});

            // backwards compatibility for existing profiles before validation for each integration was added
            this.was_already_complete = this.setup_data.complete === true &&
                (!this.setup_data.content_types || this.setup_data.content_types.length === 0 ||
                    !this.setup_data.integration_completions);
        },

        computed: {
            hasSelectedIntegrations() {
                return this.setup_data.content_types && this.setup_data.content_types.length > 0;
            },

            allSelectedIntegrationsCompleted() {
                if (!this.hasSelectedIntegrations) return true;
                if (this.was_already_complete) return true;

                return this.setup_data.content_types.every(integration => {
                    return this.integration_completions[integration] === true;
                });
            }
        },

        methods: {
            update: _.debounce(function () {
                this.doUpdate();
            }, 751),

            doUpdate() {
                if (this.provision) {
                    this.setup_data.provision_complete = this.profile.provision_info.complete_integrations;
                }

                this.setup_data.integration_completions = this.integration_completions;

                this.$rc.rest({
                    'spinner': false,
                    'endpoint': 'PUT: /api/v1/welcome/integration-settings',

                    'params': this.setup_data,

                    'on_success': (data) => {

                        this.$emit('reload');

                    },

                    'on_error': 'Unable to save integration settings',
                });
            },

            isIntegrationCompleted(integration_type) {
                return this.integration_completions[integration_type] === true;
            },

            setIntegrationCompleted(value, integration_type) {
                this.$set(this.integration_completions, integration_type, value);
                this.doUpdate();
            },

            setSectionComplete(value) {
                if (value && this.allSelectedIntegrationsCompleted) {
                    this.setup_data.complete = true;
                    this.doUpdate();
                } else if (!value) {
                    this.setup_data.complete = false;
                    this.doUpdate();
                }
            },

            isIntegrationOn(content_type) {
                if (this.setup_data == null) return false;
                if (this.setup_data.content_types == null) return false;

                return this.setup_data.content_types.includes(content_type);
            },

            setIntegration(value, content_type) {
                this.setup_data.content_types = this.setup_data.content_types.filter((el) => { return el != content_type; });

                if (value == true) {
                    this.setup_data.content_types.push(content_type);
                } else {
                    this.$set(this.integration_completions, content_type, false);
                }

                this.doUpdate();
            },
        },
    }
</script>

<style lang="scss" scoped>
.instructions {
    margin-left: 20px;
    margin-top: 15px;
    background-color: rgba(0, 0, 0, 0.05);
    padding: 15px;
    padding-left: 30px;
    border-radius: 15px;
}

.next-steps-header {
    font-weight: bold;
    font-size: 1rem;
    color: var(--v-primary-base);
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.completion-switch {
    margin-top: 1.5rem;
    padding-top: 1rem;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.section-completion {
    margin-top: 2rem;
    padding-top: 1.5rem;
    border-top: 2px solid rgba(0, 0, 0, 0.1);
}
</style>
